import type {BypassActorType} from '../bypass-actors-types'

/**
 * Display categories for the bypass actor list, in the order they should appear.
 */
export const BYPASS_ACTOR_CATEGORIES = ['Roles', 'Teams', 'Apps', 'Users', 'Other'] as const

export type BypassActorCategory = (typeof BYPASS_ACTOR_CATEGORIES)[number]

const CATEGORY_BY_ACTOR_TYPE: Record<BypassActorType, BypassActorCategory> = {
  RepositoryRole: 'Roles',
  OrganizationAdmin: 'Roles',
  EnterpriseOwner: 'Roles',
  EnterpriseRole: 'Roles',
  OrganizationRole: 'Roles',
  Team: 'Teams',
  BusinessTeam: 'Teams',
  Integration: 'Apps',
  User: 'Users',
  DeployKey: 'Other',
  RepositoryMigration: 'Other',
}

/** Category an actor should be filtered under. Unrecognized types fall under "Other". */
export function bypassActorCategory(actorType: BypassActorType): BypassActorCategory {
  return CATEGORY_BY_ACTOR_TYPE[actorType] ?? 'Other'
}

/** Filter categories for a ruleset source. Users are only suggested for repositories. */
export function availableBypassActorCategories(
  sourceType: 'repository' | 'organization' | 'enterprise',
): BypassActorCategory[] {
  return BYPASS_ACTOR_CATEGORIES.filter(category => category !== 'Users' || sourceType === 'repository')
}
